export default {
	regForm:{
		wrongLogin:"Incorrect email or password.",
		emailNotVerified:"Email not verified. Enter the code we sent you to finish registration.",
		emailAlreadyRegistered:"This email is already registered. If you forgot your password, use the password reset flow.",
	},
	system:{
		errorTitle:"Error",
		warningTitle:"Notice",
		successTitle:"Success",
	}
}
